import { useSyncExternalStore } from "react";

// Favourite tracks are kept only in this browser (localStorage), no account needed.
const KEY = "lgtdz-favorite-tracks";
const EVENT = "lgtdz-favorites-change";

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

let cache = read();
const write = (list) => {
  cache = list;
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVENT));
};

const subscribe = (cb) => {
  const onStorage = (e) => {
    if (e.key === KEY) cache = read();
    cb();
  };
  window.addEventListener(EVENT, cb);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(EVENT, cb);
    window.removeEventListener("storage", onStorage);
  };
};

export const trackKey = (t) => `${t.artist || ""}|${t.title || ""}`.toLowerCase().trim();

export const useFavorites = () => {
  const list = useSyncExternalStore(subscribe, () => cache, () => cache);
  const has = (t) => list.some((f) => f.key === trackKey(t));
  const toggle = (t) => {
    const key = trackKey(t);
    if (list.some((f) => f.key === key)) {
      write(list.filter((f) => f.key !== key));
      return false;
    }
    write([{ key, artist: t.artist, title: t.title, album: t.album || null, cover: t.cover || null,
      buy_link: t.buy_link || null, played_at: t.played_at || null, saved_at: new Date().toISOString() }, ...list]);
    return true;
  };
  const remove = (key) => write(list.filter((f) => f.key !== key));
  const addMany = (tracks) => {
    const keys = new Set(list.map((f) => f.key));
    const now = new Date().toISOString();
    const fresh = tracks.filter((t) => !keys.has(trackKey(t))).map((t) => ({ ...t, key: trackKey(t), saved_at: now }));
    if (fresh.length) write([...fresh, ...list]);
    return fresh.length;
  };
  return { list, has, toggle, remove, addMany };
};
